import React from 'react';
import { useUIColors } from '../../hooks/useTheme';

/**
 * Tabla de selección de ítems de cotización/venta (checkbox + cant. a solicitar).
 * Misma UX que el cierre de cotización vendida.
 */
const SaleLineSelectionTable = ({
  items = [],
  selectionMap = {},
  onUpdate,
  emptyLabel = 'Esta venta no tiene ítems para solicitar.',
  disabled = false,
  isDarkMode = false,
}) => {
  const ui = useUIColors();
  void isDarkMode;

  const inputStyle = {
    width: '100%',
    height: '34px',
    borderRadius: '8px',
    border: `1px solid ${ui.inputBorder}`,
    background: ui.inputBg,
    color: ui.inputText,
    padding: '0 10px',
    fontSize: '13px',
    boxSizing: 'border-box',
  };

  if (!items.length) {
    return <div style={{ fontSize: '12px', color: ui.muted }}>{emptyLabel}</div>;
  }

  return (
    <div style={{ overflowX: 'auto', border: `1px solid ${ui.border}`, borderRadius: '8px' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '640px' }}>
        <thead>
          <tr style={{ background: ui.header }}>
            {['', 'Producto', 'Unidad', 'Cant. cotizada', 'Cant. a solicitar'].map((h, idx) => (
              <th
                key={h || 'check'}
                style={{
                  padding: '8px 10px',
                  textAlign: idx >= 3 ? 'right' : 'left',
                  fontSize: '11px',
                  color: ui.muted,
                  borderBottom: `1px solid ${ui.border}`,
                  width: idx === 0 ? '40px' : undefined,
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const itemId = Number(item.id);
            const row = selectionMap[itemId] || { enabled: false, quantity: '' };
            return (
              <tr key={item.id || itemId}>
                <td style={{ padding: '8px 10px', borderBottom: `1px solid ${ui.border}` }}>
                  <input
                    type="checkbox"
                    checked={Boolean(row.enabled)}
                    onChange={(e) => onUpdate?.(itemId, 'enabled', e.target.checked)}
                    disabled={disabled}
                  />
                </td>
                <td
                  style={{
                    padding: '8px 10px',
                    fontSize: '12px',
                    color: ui.text,
                    borderBottom: `1px solid ${ui.border}`,
                  }}
                >
                  <div style={{ fontWeight: 600 }}>{item.item_name || item.product_name || '—'}</div>
                  <div style={{ fontSize: '11px', color: ui.muted }}>
                    {item.product_sku || item.item_code || '—'}
                  </div>
                </td>
                <td
                  style={{
                    padding: '8px 10px',
                    fontSize: '12px',
                    color: ui.muted,
                    borderBottom: `1px solid ${ui.border}`,
                  }}
                >
                  {item.unit || '—'}
                </td>
                <td
                  style={{
                    padding: '8px 10px',
                    fontSize: '12px',
                    textAlign: 'right',
                    borderBottom: `1px solid ${ui.border}`,
                  }}
                >
                  {Number(item.quantity || 0).toLocaleString('es-CL')}
                </td>
                <td style={{ padding: '8px 10px', borderBottom: `1px solid ${ui.border}` }}>
                  <input
                    type="number"
                    min="0"
                    step="any"
                    value={row.quantity ?? ''}
                    onChange={(e) => onUpdate?.(itemId, 'quantity', e.target.value)}
                    disabled={disabled || !row.enabled}
                    style={{ ...inputStyle, width: '100%', textAlign: 'right' }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SaleLineSelectionTable;
